// eslint-disable-next-line no-restricted-syntax
export enum REFERENCE_TYPE {
  GLOBAL = "global",
  PRESET = "preset",
  ORIGINAL = "original",
}
